import { render, staticRenderFns } from "./Semaphore.vue?vue&type=template&id=cbb55990"
import script from "./Semaphore.vue?vue&type=script&lang=js"
export * from "./Semaphore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports